import React, { Component } from "react";
import "./App.css";
import "normalize.css";
import Header from "../header/Header.js";
import api from "../chat/API.js";
import Chat from "../chat/Chat.js";
import Options from "../options/Options.js";
import Video from "../video/Video.js";
import moment from "moment-timezone";
import ioClient from "socket.io-client";
import toggleFullscreen from "./toggleFullscreen";

class App extends Component {
  constructor(props) {
    super(props);
    this.socket = null;
    this.socketUrl = "//cadernovirtual.inf.br";
    let searchParams = new URLSearchParams(window.location.search.slice(1));
    this.params = {
      namespace: searchParams.get("namespace"),
      chatRef: searchParams.get("chatRef"),
      salaId: searchParams.get("salaId"),
      authId: searchParams.get("authId"),
      cat: searchParams.get("cat"),
      readonly: parseInt(searchParams.get("readonly")),
      title: searchParams.get("title") || searchParams.get("chatRef"),
      picturesPath: searchParams.get("namespace") + "/membros/fotos/"
    };
    if (
      this.params.namespace === null ||
      this.params.chatRef === null ||
      this.params.salaId === null
    ) {
      console.log("Error: iframe params", this.params);
    }
    this.socketRoom = `${this.params.namespace}>>>${this.params.chatRef}>>>${
      this.params.salaId
    }`;
    this.state = {
      client: {},
      clients: [],
      fullscreen: false,
      socketConnected: false,
      messages: [],
      optionsActive: false,
      video: null
    };
  }

  componentWillMount() {
    const initClients = async () => {
      let clients = [];
      let client = null;

      await api.getClients(this.params).then(res => {
        if (res.data) {
          clients = res.data;
        }
      });

      // remove authenticated user from clients
      if (clients.length > 0) {
        clients = clients.filter(item => {
          if (
            item.user_id === this.params.authId &&
            item.categoria === this.params.cat
          ) {
            return false;
          } else {
            return true;
          }
        });
      }

      // is client undefined? create a new one
      await api.getClient(this.params).then(res => {
        if (res.data[0]) {
          client = {
            categoria: res.data[0].categoria,
            foto: res.data[0].foto,
            nome: res.data[0].nome,
            situacao: "A", // active
            sala_id: this.params.salaId,
            user_id: this.params.authId,
            chatRef: this.params.chatRef,
            socketRoom: this.socketRoom,
            namespace: this.params.namespace
          };
          api.setClient(this.params, client).then(res => {
            client.id = res.data[0].id;
          });
        } else {
          console.log("Usuário inválido.");
        }
      });

      // is client still undefined ? terminate
      if (!client) {
        alert("Usuário inválido. Por favor, tente novamente.");
        return false;
      }

      // client is defined
      if (client) {
        clients.unshift(client);
        this.setState({ clients, client });
      }

      // Try to connect for 30 seconds
      let count = 30;
      this.socket = ioClient(this.socketUrl, { path: "/server/socket.io" });
      let timeout = await setInterval(() => {
        if (this.socket.connected) {
          // join client to the websocket chat room
          this.socket.emit("join", client);

          this.setState({ socketConnected: true });
          this.socketInitListening();
        }

        if (this.socket.connected || count === 0) {
          clearInterval(timeout);
        }

        count--;
      }, 1000);
    };
    initClients();

    api.getMessages(this.params).then(res => {
      if (res.data) {
        this.setState({ messages: res.data });
      }
    });

    api.getVideo(this.params).then(res => {
      if (res.data) {
        let video = res.data[0].video;
        this.setState({ video });
      }
    });
  }

  socketInitListening() {
    this.socket.on("message", msg => {
      msg.envio = moment
        .tz(msg.envio, "YYYY-MM-DD HH:mm:ss", "America/Sao_Paulo")
        .format("DD/MM/YYYY HH:mm:ss");
      let messages = this.state.messages;
      messages.push(msg);
      this.setState({ messages });
    });

    this.socket.on("refresh status", allConnected => {
      this.refreshStatus(allConnected);
    });
  }

  refreshStatus(allConnected) {
    let clients = this.state.clients.map(client => {
      let match = allConnected.filter(item => {
        return (
          client.user_id === item.user_id && client.categoria === item.categoria
        );
      });
      client.situacao = match.length > 0 ? "A" : "I";
      return client;
    });
    this.setState({ clients });
  }

  handleFullscreen() {
    let fullscreen = !this.state.fullscreen;
    this.setState({ fullscreen });
    toggleFullscreen(fullscreen);
  }

  handleOptions(action) {
    let optionsActive = action;
    this.setState({ optionsActive });
  }

  handleSend(message) {
    if (message && !this.readonly) {
      message = {
        mensagem: message,
        envio: moment.tz("America/Sao_Paulo").format("YYYY-MM-DD HH:mm:ss"),
        categoria: this.state.client.categoria,
        participante_id: this.state.client.id,
        participante_nome: this.state.client.nome,
        participante_foto: this.state.client.foto,
        user_id: this.state.client.user_id,
        socketRoom: this.socketRoom
      };
      api.setMessage(this.params, message).then(res => {
        if (res.status === 200) {
          this.socket.emit("message", message);
        }
      });
    }
  }

  render() {
    let video = "";
    if (this.state.video) {
      video = <Video url={this.state.video} />;
    }

    if (this.state.socketConnected) {
      return (
        <div
          className={
            "container " +
            (video ? "has-video " : "no-video ") +
            (this.state.fullscreen ? "fullscreen" : "")
          }
        >
          <Header
            handleOptions={this.handleOptions.bind(this)}
            chatRef={this.params.chatRef}
            handleFullscreen={this.handleFullscreen.bind(this)}
            fullscreen={this.state.fullscreen}
            headerTitle={this.params.title}
          />
          {video}
          <Chat
            messages={this.state.messages}
            client={this.state.client}
            handleSend={this.handleSend.bind(this)}
            readonly={this.params.readonly}
          />
          <Options
            active={this.state.optionsActive}
            clients={this.state.clients}
            picturesPath={this.params.picturesPath}
            handleOptions={this.handleOptions.bind(this)}
          />
        </div>
      );
    } else {
      return (
        <div className="loading">
          <span>
            <i className="spinner" />
          </span>
        </div>
      );
    }
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/App.js